/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Fact_PriceInputs */

const en_wc_fact_price = /** @type {(inputs: Wc_Fact_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0`)
};

/**
* | output |
* | --- |
* | "$0" |
*
* @param {Wc_Fact_PriceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_fact_price = /** @type {((inputs?: Wc_Fact_PriceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Fact_PriceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_fact_price(inputs)
});
export { wc_fact_price as "wc.fact.price" }